/* eslint-disable arrow-parens */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useState, useEffect } from 'react';
import { format } from 'date-fns';
import { Link } from 'react-router-dom';

import { Container, Card } from './styles';
import api from '~/services/api';

const levels = ['Iniciante', 'Básico', 'Intermediário', 'Avançado', 'Master'];

export default function Mail() {
  const [jobs, setJobs] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    async function getData() {
      const { data } = await api.get('/jobs');
      setJobs(data);
    }
    getData();
  }, []);

  return (
    <>
      <h1 style={{ color: '#36ded6', marginLeft: 30, paddingTop: 30 }}>
        Vagas Disponíveis
      </h1>
      <Container>
        {jobs.map((job) => {
          const year = job.updated_at.slice(0, 4);
          const month = job.updated_at.slice(6, 7);
          const day = job.updated_at.slice(8, 10);

          const tags = job.area_job.split(',');

          return job.status === 'open' ? (
            <Link key={job.id} to={`jobs/${job.id}`}>
              <Card>
                <div className="header">
                  <img src={`${job.file.url}`} alt="image_job" />
                  <div>
                    <p style={{ fontWeight: 'bold' }}> {job.company} </p>
                    <p>
                      Vaga aberta em:{' '}
                      {format(new Date(year, month - 1, day), 'dd/MM/yyyy')}
                    </p>
                    <p> Nível Apollo: {levels[job.apollo_level - 1]}</p>
                  </div>
                </div>
                <div className="middle">
                  <p className="title">{job.title}</p>
                  <p className="detail">
                    {job.type_job} em {job.local}
                  </p>
                  <p className="salario">
                    Salário:{' '}
                    {job.salary
                      ? `R$ ${parseFloat(job.salary).toFixed(2)}`
                      : 'Nāo Informado'}
                  </p>
                </div>
                <div className="bottom">
                  {tags.map((tag) => (
                    <div className="tag" key={tag}>
                      <div className="circle" key={tag} />
                      <p>{tag}</p>
                    </div>
                  ))}
                </div>
              </Card>
            </Link>
          ) : null;
        })}
      </Container>
    </>
  );
}
